<label>
  <ng-content select="app-form-field-label"></ng-content>
</label>

<ng-content></ng-content>

<ng-content select="app-form-field-error"></ng-content>
